// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator-finder {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    margin: 20px;
    padding: 20px;
    color: #333;
  }
  .operator-finder  p{
    line-height: 30px;
    color:var(--primary-grey);
  }
  header {
    text-align: center;
    margin-bottom: 20px;
  }
  
  header h1 {
    color: var(--primary-blue);
  }
  header p{
    font-weight: bolder;
  }
  
  .operator-finder-content {
    margin-bottom: 20px;
  }
  
  .operator-finder-box-peragraph {
    font-weight: bolder;
  }
  
  .operator-finder-content-in-contact {
    display: flex;
    /* justify-content: center; */
    gap: 10px;
    margin-bottom: 20px;
    /* margin-top: 30px; */
  }
  
  .operator-finder-content-in-contact button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    color: white;
    font-size: 16px;
    cursor: pointer;
  }
  
  .operator-finder-content-in-contact .whatsapp {
    background-color: #25d366;
  }
  
  .operator-finder-content-in-contact .telegram {
    background-color: #0088cc;
  }
  
  .operator-finder-content-in-contact .skype {
    background-color: #00aff0;
  }
  
  .illustration {
    text-align: center;
  }
  
  .illustration img {
    max-width: 100%;
    height: auto;
  }
  .operator-finder-content-box{
    display: flex;
  }

  
  .operator-finder-content-box2{
    margin-bottom: 40px;
  }


  
.operator-finder-container {
  font-family: Arial, sans-serif;
  margin: 20px;
  padding: 20px;
  /* background: #e2ecff8a; */
  /* backdrop-filter: blur(10px); */
  /* border: 1px solid #ddd; */
  /* border-radius: 8px; */
  position: relative;
  z-index: 1;
}


.operator-finder-sim-box{
  display: flex;
  gap: 50px;
}


.operator-finder-container p {
  line-height: 2rem;
  color: var(--primary-grey);
  margin: 10px 0;
}

.operator-finder-container h1 {
  color: var(--primary-blue);
  font-size: 34px;
  margin-bottom: 30px;
}
.operator-finder-container h2 {
  color: var(--primary-blue);
  font-size: 20px;
  margin-top: 20px;
}

.operator-finder-container ul {
  margin: 10px 0;
  padding-left: 20px;
  color: #666;
}

.operator-finder-container ul li {
  margin: 5px 0;
  line-height: 30px;
}

@media (max-width: 1024px){
  .operator-finder-content-box,
  .operator-finder-sim-box{
    align-items: center;
    flex-direction: column;
  }
  .operator-finder-content-img-box img,
  .operator-finder-sim-img img{
    width: 100%;
    max-width: 550px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/VAS_Service/Finder/OperatorFinder.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,SAAS;IACT,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;EACf;;;EAGA;IACE,mBAAmB;EACrB;;;;AAIF;EACE,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,iCAAiC;EACjC,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,SAAS;AACX;;;AAGA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;;IAEE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;;IAEE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":[".operator-finder {\n    font-family: Arial, sans-serif;\n    line-height: 1.6;\n    margin: 20px;\n    padding: 20px;\n    color: #333;\n  }\n  .operator-finder  p{\n    line-height: 30px;\n    color:var(--primary-grey);\n  }\n  header {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n  header h1 {\n    color: var(--primary-blue);\n  }\n  header p{\n    font-weight: bolder;\n  }\n  \n  .operator-finder-content {\n    margin-bottom: 20px;\n  }\n  \n  .operator-finder-box-peragraph {\n    font-weight: bolder;\n  }\n  \n  .operator-finder-content-in-contact {\n    display: flex;\n    /* justify-content: center; */\n    gap: 10px;\n    margin-bottom: 20px;\n    /* margin-top: 30px; */\n  }\n  \n  .operator-finder-content-in-contact button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n  }\n  \n  .operator-finder-content-in-contact .whatsapp {\n    background-color: #25d366;\n  }\n  \n  .operator-finder-content-in-contact .telegram {\n    background-color: #0088cc;\n  }\n  \n  .operator-finder-content-in-contact .skype {\n    background-color: #00aff0;\n  }\n  \n  .illustration {\n    text-align: center;\n  }\n  \n  .illustration img {\n    max-width: 100%;\n    height: auto;\n  }\n  .operator-finder-content-box{\n    display: flex;\n  }\n\n  \n  .operator-finder-content-box2{\n    margin-bottom: 40px;\n  }\n\n\n  \n.operator-finder-container {\n  font-family: Arial, sans-serif;\n  margin: 20px;\n  padding: 20px;\n  /* background: #e2ecff8a; */\n  /* backdrop-filter: blur(10px); */\n  /* border: 1px solid #ddd; */\n  /* border-radius: 8px; */\n  position: relative;\n  z-index: 1;\n}\n\n\n.operator-finder-sim-box{\n  display: flex;\n  gap: 50px;\n}\n\n\n.operator-finder-container p {\n  line-height: 2rem;\n  color: var(--primary-grey);\n  margin: 10px 0;\n}\n\n.operator-finder-container h1 {\n  color: var(--primary-blue);\n  font-size: 34px;\n  margin-bottom: 30px;\n}\n.operator-finder-container h2 {\n  color: var(--primary-blue);\n  font-size: 20px;\n  margin-top: 20px;\n}\n\n.operator-finder-container ul {\n  margin: 10px 0;\n  padding-left: 20px;\n  color: #666;\n}\n\n.operator-finder-container ul li {\n  margin: 5px 0;\n  line-height: 30px;\n}\n\n@media (max-width: 1024px){\n  .operator-finder-content-box,\n  .operator-finder-sim-box{\n    align-items: center;\n    flex-direction: column;\n  }\n  .operator-finder-content-img-box img,\n  .operator-finder-sim-img img{\n    width: 100%;\n    max-width: 550px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
